import Vuex from "vuex";

import admin from "./admin";
import autocompletes from "./autocompletes";
import hosts from "./hosts";
import kb from "./kb";
import notifications from "./notifications";
import projects from "./projects";
import prospects from "./prospects";
import ui from "./ui";
import user from "./user";
import comments from "./comments";
import timeline from "./timeline";
import announcements from "./announcements";
import signatureTemplates from "./signatureTemplates";

const store = new Vuex.Store({
  modules: {
    admin,
    announcements,
    autocompletes,
    hosts,
    kb,
    notifications,
    projects,
    prospects,
    ui,
    user,
    comments,
    timeline,
    signatureTemplates
  }
});

export default store;
